const BASE_URL_AUTH: string = process.env.NEXT_PUBLIC_API_AUTH_URL || "";
const BASE_URL_RESOURCE: string =
  process.env.NEXT_PUBLIC_API_RESOURCE_URL || "";

const LOGIN = "/authentication/session";

const APP_SETTING = {
  ACCESS_FETCH_LIST: "/app-setting/access/paging",
  ACCESS_FETCH_BY_ID: `/app-setting/access`,
  ACCESS_CREATE: `/app-setting/access`,
  ACCESS_UPDATE: `/app-setting/access`,
  ACCESS_DELETE: `/app-setting/access`,

  CLIENT_APP_VERSION_FETCH_LIST: "/app-setting/client-app-version/paging",
  CLIENT_APP_VERSION_FETCH_BY_ID: `/app-setting/client-app-version`,
  CLIENT_APP_VERSION_CREATE: `/app-setting/client-app-version`,
  CLIENT_APP_VERSION_UPDATE: `/app-setting/client-app-version`,
  CLIENT_APP_VERSION_DELETE: `/app-setting/client-app-version`,

  ENTITY_FETCH_LIST: "/app-setting/entity/paging",
  ENTITY_FETCH_BY_ID: `/app-setting/entity`,
  ENTITY_CREATE: `/app-setting/entity`,
  ENTITY_UPDATE: `/app-setting/entity`,
  ENTITY_DELETE: `/app-setting/entity`,

  FEATURE_FETCH_LIST: "/app-setting/feature/paging",
  FEATURE_FETCH_BY_ID: `/app-setting/feature`,
  FEATURE_CREATE: `/app-setting/feature`,
  FEATURE_UPDATE: `/app-setting/feature`,
  FEATURE_DELETE: `/app-setting/feature`,

  PARAMETER_FETCH_LIST: "/app-setting/parameter/paging",
  PARAMETER_FETCH_BY_ID: `/app-setting/parameter`,
  PARAMETER_CREATE: `/app-setting/parameter`,
  PARAMETER_UPDATE: `/app-setting/parameter`,
  PARAMETER_DELETE: `/app-setting/parameter`,

  PARAMETER_ITEM_FETCH_LIST: "/app-setting/parameter-item/paging",
  PARAMETER_ITEM_FETCH_BY_ID: `/app-setting/parameter-item`,
  PARAMETER_ITEM_CREATE: `/app-setting/parameter-item`,
  PARAMETER_ITEM_UPDATE: `/app-setting/parameter-item`,
  PARAMETER_ITEM_DELETE: `/app-setting/parameter-item`,

  ROLE_FETCH_LIST: "/app-setting/role/paging",
  ROLE_FETCH_BY_ID: `/app-setting/role`,
  ROLE_CREATE: `/app-setting/role`,
  ROLE_UPDATE: `/app-setting/role`,
  ROLE_DELETE: `/app-setting/role`,

  TASK_SCHEDULE_FETCH_LIST: "/app-setting/task-schedule/paging",
  TASK_SCHEDULE_FETCH_BY_ID: `/app-setting/task-schedule`,
  TASK_SCHEDULE_CREATE: `/app-setting/task-schedule`,
  TASK_SCHEDULE_UPDATE: `/app-setting/task-schedule`,
  TASK_SCHEDULE_DELETE: `/app-setting/task-schedule`,

  USER_FETCH_LIST: "/app-setting/user/paging",
  USER_FETCH_BY_ID: `/app-setting/user`,
  USER_CREATE: `/app-setting/user`,
  USER_UPDATE: `/app-setting/user`,
  USER_DELETE: `/app-setting/user`,
};

const MASTER_DATA = {
  BATTERY_FETCH_LIST: "/master-data/battery/paging",
  BATTERY_FETCH_BY_ID: `/master-data/battery`,
  BATTERY_CREATE: `/master-data/battery`,
  BATTERY_UPDATE: `/master-data/battery`,
  BATTERY_DELETE: `/master-data/battery`,
  BATTERY_GET_DETAIL_MOTORCYCLE: `/master-data/battery/detail-motorcycle`,
  BATTERY_GET_DETAIL_IMEI: `/master-data/battery/detail-imei`,
  BATTERY_SEND_COMMAND_TO_BATTERY: `/master-data/battery/command`,
  BATTERY_SYNC: `/master-data/battery/sync`,

  CABINET_FETCH_LIST: "/master-data/cabinet/paging",
  CABINET_FETCH_BY_ID: `/master-data/cabinet`,
  CABINET_CREATE: `/master-data/cabinet`,
  CABINET_UPDATE: `/master-data/cabinet`,
  CABINET_DELETE: `/master-data/cabinet`,
  CABINET_RESTART: (id: string) => `/master-data/cabinet/${id}/command/restart`,
  CABINET_TOGGLE_DOOR_STATUS: `/master-data/cabinet-detail/door`,
  CABINET_OPEN_DOOR: `/master-data/cabinet-detail/open-door`,
  CABINET_GET_DETAIL_IMEI: `/master-data/cabinet/detail-imei`,
  CABINET_SYNC: `/master-data/cabinet/sync`,

  CABINET_DETAIL_FETCH_LIST: "/master-data/cabinet-detail/paging",
  CABINET_DETAIL_FETCH_BY_ID: `/master-data/cabinet-detail`,
  CABINET_DETAIL_CREATE: `/master-data/cabinet-detail`,
  CABINET_DETAIL_UPDATE: `/master-data/cabinet-detail`,
  CABINET_DETAIL_DELETE: `/master-data/cabinet-detail`,

  CABINET_DETAIL_LOG_FETCH_LIST: "/master-data/cabinet-detail-log/paging",
  CABINET_DETAIL_LOG_FETCH_BY_ID: `/master-data/cabinet-detail-log`,
  CABINET_DETAIL_LOG_CREATE: `/master-data/cabinet-detail-log`,
  CABINET_DETAIL_LOG_UPDATE: `/master-data/cabinet-detail-log`,
  CABINET_DETAIL_LOG_DELETE: `/master-data/cabinet-detail-log`,

  CABINET_DETAIL_LOG_HISTORY_FETCH_LIST:
    "/master-data/cabinet-detail-log/history",
  CABINET_DETAIL_DOOR_FETCH_LIST: "/master-data/cabinet-detail/door",

  CITY_FETCH_LIST: "/master-data/city/paging",
  CITY_FETCH_BY_ID: `/master-data/city`,
  CITY_CREATE: `/master-data/city`,
  CITY_UPDATE: `/master-data/city`,
  CITY_DELETE: `/master-data/city`,

  CITY_FETCH_OPTIONS: "master-data/city/by-province?province_id=",

  CUSTOMER_FETCH_LIST: "/master-data/customer/paging",
  CUSTOMER_FETCH_BY_ID: `/master-data/customer`,
  CUSTOMER_CREATE: `/master-data/customer`,
  CUSTOMER_UPDATE: `/master-data/customer`,
  CUSTOMER_DELETE: `/master-data/customer`,

  IOT_DEVICE_FETCH_LIST: "/master-data/iot-device/paging",
  IOT_DEVICE_FETCH_BY_ID: `/master-data/iot-device`,
  IOT_DEVICE_CREATE: `/master-data/iot-device`,
  IOT_DEVICE_UPDATE: `/master-data/iot-device`,
  IOT_DEVICE_DELETE: `/master-data/iot-device`,
  IOT_DEVICE_HISTORY_LOCATION: `/master-data/iot-device/history`,

  MOTORCYCLE_FETCH_LIST: "/master-data/motorcycle/paging",
  MOTORCYCLE_FETCH_BY_ID: `/master-data/motorcycle`,
  MOTORCYCLE_CREATE: `/master-data/motorcycle`,
  MOTORCYCLE_UPDATE: `/master-data/motorcycle`,
  MOTORCYCLE_DELETE: `/master-data/motorcycle`,
  MOTORCYCLE_GET_HITORY_TRX: `/master-data/motorcycle/history/paging`,
  MOTORCYCLE_PAID_OFF_DEBT_HISTORY: `/master-data/motorcycle/paid-off-debt/history`,

  MOTORCYCLE_BATTERY_FETCH_LIST: "/master-data/motorcycle-battery/paging",
  MOTORCYCLE_BATTERY_FETCH_BY_ID: `/master-data/motorcycle-battery`,
  MOTORCYCLE_BATTERY_CREATE: `/master-data/motorcycle-battery`,
  MOTORCYCLE_BATTERY_UPDATE: `/master-data/motorcycle-battery`,
  MOTORCYCLE_BATTERY_DELETE: `/master-data/motorcycle-battery`,
  MOTORCYCLE_GET_DETAIL_IMEI: `/master-data/motorcycle/detail-imei`,
  MOTORCYCLE_ADD_NOPOL: `/master-data/motorcycle-registered`,
  MOTORCYCLE_DELETE_NOPOL: (id: number) =>
    `/master-data/motorcycle-registered/${id}`,
  MOTORCYCLE_GET_PHOTO_STNK: `/master-data/motorcycle-registered/stnk`,
  MOTORCYCLE_GET_RENT_STATUS: `/master-data/motorcycle-rent-status/paging`,
  MOTORCYCLE_GET_RENT_AVAILABLE: `/master-data/motorcycle/criteria`,
  MOTORCYCLE_GET_TYPE_MOTORCYCLE: `/master-data/motorcycle/for-list-model`,

  MOTORCYCLE_BATTERY_LOG_FETCH_LIST:
    "/master-data/motorcycle-battery-log/paging",
  MOTORCYCLE_BATTERY_LOG_FETCH_BY_ID: `/master-data/motorcycle-battery-log`,
  MOTORCYCLE_BATTERY_LOG_CREATE: `/master-data/motorcycle-battery-log`,
  MOTORCYCLE_BATTERY_LOG_UPDATE: `/master-data/motorcycle-battery-log`,
  MOTORCYCLE_BATTERY_LOG_DELETE: `/master-data/motorcycle-battery-log`,

  MOTORCYCLE_OWNERSHIP_FETCH_LIST: "/master-data/motorcycle-ownership/paging",
  MOTORCYCLE_OWNERSHIP_FETCH_BY_ID: `/master-data/motorcycle-ownership`,
  MOTORCYCLE_OWNERSHIP_CREATE: `/master-data/motorcycle-ownership`,
  MOTORCYCLE_OWNERSHIP_UPDATE: `/master-data/motorcycle-ownership`,
  MOTORCYCLE_OWNERSHIP_DELETE: `/master-data/motorcycle-ownership`,

  MOTORCYCLE_REGISTERED_FETCH_LIST: "/master-data/motorcycle-registered/paging",
  MOTORCYCLE_REGISTERED_FETCH_BY_ID: `/master-data/motorcycle-registered`,
  MOTORCYCLE_REGISTERED_CREATE: `/master-data/motorcycle-registered`,
  MOTORCYCLE_REGISTERED_UPDATE: `/master-data/motorcycle-registered`,
  MOTORCYCLE_REGISTERED_DELETE: `/master-data/motorcycle-registered`,

  MOTORCYCLE_ACTIVATION_ENGINE: `/master-data/motorcycle/on-off`,
  // MOTORCYCLE_HISTORY_LOG_IGNITION: `/master-data/iot-device-log/log-history`,
  MOTORCYCLE_HISTORY_LOG_IGNITION: `/master-data/iot-device-log/paging`,
  MOTORCYCLE_REVERT_ACTIVATION: "/master-data/motorcycle/revert-activation",
  MOTORCYCLE_RETRIEVED: "/master-data/motorcycle/retrieve-motorcycle",
  MOTORCYCLE_BATCH_TEMPLATE: "/master-data/motorcycle/insert-bulk/download",
  MOTORCYCLE_BATCH_ADD: "/master-data/motorcycle/insert-bulk",

  PRODUCT_FETCH_LIST: "/master-data/product/paging",
  PRODUCT_FETCH_BY_ID: `/master-data/product`,
  PRODUCT_CREATE: `/master-data/product`,
  PRODUCT_UPDATE: `/master-data/product`,
  PRODUCT_DELETE: `/master-data/product`,

  PRODUCT_CATEGORY_FETCH_LIST: "/master-data/product-category/paging",
  PRODUCT_CATEGORY_FETCH_BY_ID: `/master-data/product-category`,
  PRODUCT_CATEGORY_CREATE: `/master-data/product-category`,
  PRODUCT_CATEGORY_UPDATE: `/master-data/product-category`,
  PRODUCT_CATEGORY_DELETE: `/master-data/product-category`,
  PRODUCT_GET_CATEGORY: `/master-data/product-category`,
  PRODUCT_GET_LIST: "master-data/product",

  PROVINCE_FETCH_LIST: "/master-data/province/paging",
  PROVINCE_FETCH_BY_ID: `/master-data/province`,
  PROVINCE_CREATE: `/master-data/province`,
  PROVINCE_UPDATE: `/master-data/province`,
  PROVINCE_DELETE: `/master-data/province`,

  PROVINCE_FETCH_OPTIONS: "/master-data/province",

  SIM_CARD_FETCH_LIST: "/master-data/sim-card/paging",
  SIM_CARD_FETCH_BY_ID: `/master-data/sim-card`,
  SIM_CARD_CREATE: `/master-data/sim-card`,
  SIM_CARD_UPDATE: `/master-data/sim-card`,
  SIM_CARD_DELETE: `/master-data/sim-card`,

  STAFF_FETCH_LIST: "/master-data/staff/paging",
  STAFF_FETCH_BY_ID: `/master-data/staff`,
  STAFF_CREATE: `/master-data/staff`,
  STAFF_UPDATE: `/master-data/staff`,
  STAFF_DELETE: `/master-data/staff`,

  TERM_AND_CONDITION_FETCH_LIST: "/master-data/term-condition/paging",
  TERM_AND_CONDITION_FETCH_BY_ID: "/master-data/term-condition",
  TERM_AND_CONDITION_CREATE: "/master-data/term-condition",
  TERM_AND_CONDITION_UPDATE: "/master-data/term-condition",
  TERM_AND_CONDITION_DELETE: "/master-data/term-condition",

  POOL_FETCH_LIST: "/master-data/motorcycle-pool/paging",
  POOL_FETCH_BY_ID: `/master-data/motorcycle-pool`,
  POOL_CREATE: `/master-data/motorcycle-pool`,
  POOL_UPDATE: `/master-data/motorcycle-pool`,
  POOL_DELETE: `/master-data/motorcycle-pool`,
  POOL_INFORMATION_MOTORCYCLE: `/master-data/motorcycle/paging`,
  POOL_INFROMATION_PRODUCT_GROUP: `/master-data/product-group/paging`,
  POOL_MOTORCYCLE_LIST: `/master-data/motorcycle/list`,
  POOL_PAIR_MOTORCYCLE: (id: string | number): string =>
    `/master-data/motorcycle/${id}/pair`,
  POOL_UNPAIR_MOTORCYCLE: (id: string | number): string =>
    `/master-data/motorcycle/${id}/unpair`,
  POOL_PAIR_PRODUCT_GROUP: (id: string | number): string =>
    `/master-data/motorcycle-pool/${id}/pair-product-group`,
  POOL_UNPAIR_PRODUCT_GROUP: (id: string | number): string =>
    `/master-data/motorcycle-pool/${id}/unpair-product-group`,
};

const TRANSACTION_DATA = {
  TRANSACTION_BATTERY_FETCH_LIST: "/transaction-data/battery/package/paging",
  TRANSACTION_BATTERY_FETCH_BY_ID: `/transaction-data/transaction-battery`,
  TRANSACTION_BATTERY_CREATE: `/transaction-data/transaction-battery`,
  TRANSACTION_BATTERY_UPDATE: `/transaction-data/transaction-battery`,
  TRANSACTION_BATTERY_DELETE: `/transaction-data/transaction-battery`,

  TRANSACTION_HEADER_FETCH_LIST: "/transaction-data/transaction-header/paging",
  TRANSACTION_HEADER_FETCH_BY_ID: `/transaction-data/transaction-header`,
  TRANSACTION_HEADER_CREATE: `/transaction-data/transaction-header`,
  TRANSACTION_HEADER_UPDATE: `/transaction-data/transaction-header`,
  TRANSACTION_HEADER_DELETE: `/transaction-data/transaction-header`,

  TRANSACTION_ITEM_FETCH_LIST: "/transaction-data/transaction-item/paging",
  TRANSACTION_ITEM_FETCH_BY_ID: `/transaction-data/transaction-item`,
  TRANSACTION_ITEM_CREATE: `/transaction-data/transaction-item`,
  TRANSACTION_ITEM_UPDATE: `/transaction-data/transaction-item`,
  TRANSACTION_ITEM_DELETE: `/transaction-data/transaction-item`,

  TRANSACTION_RENT_MOTORCYCLE_FETCH_LIST:
    "/transaction-data/transaction-rent-motorcycle/paging",
  TRANSACTION_RENT_MOTORCYCLE_FETCH_BY_ID: `/transaction-data/transaction-rent-motorcycle`,
  TRANSACTION_RENT_MOTORCYCLE_CREATE: `/transaction-data/transaction-rent-motorcycle`,
  TRANSACTION_RENT_MOTORCYCLE_UPDATE: `/transaction-data/transaction-rent-motorcycle`,
  TRANSACTION_RENT_MOTORCYCLE_DELETE: `/transaction-data/transaction-rent-motorcycle`,
  TRANSACTION_MOTORCYCLE_DETAIL_TRX: `/master-data/motorcycle/detail-trx`,

  TRANSACTION_RENT_PRODUCT_FETCH_LIST:
    "/transaction-data/transaction-rent-product/paging",
  TRANSACTION_RENT_PRODUCT_FETCH_BY_ID: `/transaction-data/transaction-rent-product`,
  TRANSACTION_RENT_PRODUCT_CREATE: `/transaction-data/transaction-rent-product`,
  TRANSACTION_RENT_PRODUCT_UPDATE: `/transaction-data/transaction-rent-product`,
  TRANSACTION_RENT_PRODUCT_DELETE: `/transaction-data/transaction-rent-product`,

  TRANSACTION_RENT_PACKAGE_FETCH_LIST: "/transaction-data/rent/package/paging",
  TRANSACTION_RENT_PACKAGE_FETCH_BY_ID: `/transaction-data/rent/package`,
  TRANSACTION_RENT_PACKAGE_CREATE: `/transaction-data/transaction-rent-package`,
  TRANSACTION_RENT_PACKAGE_UPDATE: `/transaction-data/transaction-rent-package`,
  TRANSACTION_RENT_PACKAGE_DELETE: `/transaction-data/transaction-rent-package`,

  TRANSACTION_STATUS_FETCH_LIST: "/transaction-data/transaction-status/paging",
  TRANSACTION_STATUS_FETCH_BY_ID: `/transaction-data/transaction-status`,
  TRANSACTION_STATUS_CREATE: `/transaction-data/transaction-status`,
  TRANSACTION_STATUS_UPDATE: `/transaction-data/transaction-status`,
  TRANSACTION_STATUS_DELETE: `/transaction-data/transaction-status`,

  TRANSACTION_TOPUP_FETCH_LIST: "/transaction-data/transaction-topup/paging",
  TRANSACTION_TOPUP_FETCH_BY_ID: `/transaction-data/transaction-topup`,
  TRANSACTION_TOPUP_CREATE: `/transaction-data/transaction-topup`,
  TRANSACTION_TOPUP_UPDATE: `/transaction-data/transaction-topup`,
  TRANSACTION_TOPUP_DELETE: `/transaction-data/transaction-topup`,

  TRANSACTION_TYPE_FETCH_LIST: "/transaction-data/transaction-type/paging",
  TRANSACTION_TYPE_FETCH_BY_ID: `/transaction-data/transaction-type`,
  TRANSACTION_TYPE_CREATE: `/transaction-data/transaction-type`,
  TRANSACTION_TYPE_UPDATE: `/transaction-data/transaction-type`,
  TRANSACTION_TYPE_DELETE: `/transaction-data/transaction-type`,

  TRANSACTION_WALLET_FETCH_LIST: "/transaction-data/transaction-wallet/paging",
  TRANSACTION_WALLET_FETCH_BY_ID: `/transaction-data/transaction-wallet`,
  TRANSACTION_WALLET_CREATE: `/transaction-data/transaction-wallet`,
  TRANSACTION_WALLET_UPDATE: `/transaction-data/transaction-wallet`,
  TRANSACTION_WALLET_DELETE: `/transaction-data/transaction-wallet`,

  TRANSACTION_CHARGING_AND_SWAPPING_FETCH_LIST:
    "/transaction-data/charging-swapping/paging",
  TRANSACTION_CHARGING_AND_SWAPPING_FETCH_BY_ID: `/transaction-data/charging-swapping`,
  TRANSACTION_CHARGING_AND_SWAPPING_CREATE: `/transaction-data/transaction-charging-and-swapping`,
  TRANSACTION_CHARGING_AND_SWAPPING_UPDATE: `/transaction-data/transaction-charging-and-swapping`,
  TRANSACTION_CHARGING_AND_SWAPPING_DELETE: `/transaction-data/transaction-charging-and-swapping`,
  TRANSACTION_CHARGING_AND_SWAPPRING_DOOR_FETCH_LIST:
    "/transaction-data/transaction-charging-and-swapping/door-info",
  TRANSACTION_CHARGING_AND_SWAPPING_INFO_DOOR_FETCH_LIST:
    "/transaction-data/charging-swapping/info-door/paging",
};

const PRODUCT = {
  PRODUCT_PRODUCT_DATA_FETCH_LIST: "/master-data/product/paging",
  PRODUCT_PRODUCT_DATA_FETCH_BY_ID: `/product/product-data`,
  PRODUCT_PRODUCT_DATA_CREATE: `/product/product-data`,
  PRODUCT_PRODUCT_DATA_UPDATE: `/product/product-data`,
  PRODUCT_PRODUCT_DATA_DELETE: `/product/product-data`,

  PRODUCT_GROUP_PRODUCT_DATA_FETCH_LIST: "/master-data/product-group/paging",
  PRODUCT_GROUP_PRODUCT_DATA_FETCH_BY_ID: `/master-data/product-group`,
  PRODUCT_GROUP_PRODUCT_DATA_CREATE: `/master-data/product-group`,
  PRODUCT_GROUP_PRODUCT_DATA_UPDATE: (id: string | number) =>
    `/master-data/product-group/${id}`,
  PRODUCT_GROUP_PRODUCT_DATA_DELETE: `/master-data/product-group`,
  PRODUCT_GROUP_ADD_PRODUCT_DATA: (id: string | number) =>
    `/master/data/product-group/${id}/add-product-data`,
};

const DRIVER = {
  DRIVERS_DATA_FETCH_LIST: "/driver/paging",
  DRIVERS_DATA_FETCH_BY_ID: `/driver`,
  DRIVERS_DATA_CREATE: `/driver`,
  DRIVERS_DATA_UPDATE: `/driver`,
  DRIVERS_DATA_DELETE: `/driver`,
  DRIVERS_GET_LINK_DOC_DRIVER: "/driver/get-link",
  DRIVERS_GET_DETAIL_TRANSACTION_ACTIVATION: "/driver/trx",
  DRIVERS_UPDATE_MOTORCYCLE_BATTERY: "/driver/update-battery",
  DRIVERS_UNLINK_MOTORCYCLE_BATTERY: "/driver/unlink-battery",
  DRIVERS_ADD_MOTORCYCLE_BATTERY: "/driver/link-battery",
  DRIVERS_UPDATE_STATUS: "/driver/update-status",
  DRIVERS_UPDATE_PERSONAL_DATA: "/driver/profile",
  DRIVERS_UPDATE_DOCUMENT: "/driver/document",
  DRIVERS_UPDATE_APPLICATION_DATA: "/driver/application",
  DRIVERS_UPLOAD_IMAGE_DRIVER: "/driver/upload-image",
  DRIVERS_GET_LOG_MOTOR_LIST: "/driver/log-motorcycle/paging",
  DRIVERS_GET_HISTORY_TRX_ACTIVATION_LIST: "/driver/trx-activation/paging",
  DRIVERS_SWITCH_MOTORCYCLE: "/driver/trx",
  DRIVERS_PAIR_PRODUCT_GROUP_TO_DRIVER: "/driver/update-product-group",
  DRIVERS_RESET_PIN: "/driver/reset",
  DRIVERS_ADD_BALANCE_WITHDRAWAL:
    "/transaction-data/transaction-balance-withdrawal/form",
  DRIVERS_ADD_DEPOSIT_WITHDRAWAL:
    "/transaction-data/transaction-deposit-withdrawal/form",
  DRIVERS_DOWNLOAD_TEMPLATE_BALANCE_WITHDRAWAL:
    "/transaction-data/transaction-balance-withdrawal/form",
  DRIVERS_DOWNLOAD_TEMPLATE_DEPOSIT_WITHDRAWAL:
    "/transaction-data/transaction-deposit-withdrawal/form",
  DRIVER_APPROVAL_BALANCE_WITHDRAWAL:
    "/transaction-data/transaction-balance-withdrawal/update-status",
  DRIVER_APPROVAL_DEPOSIT_WITHDRAWAL:
    "/transaction-data/transaction-deposit-withdrawal/update-status",
  DRIVER_DOWNLOAD_EVIDENCE: (url: string) =>
    `/transaction-data/transaction-balance-withdrawal/download-evidence?url=${url}`,
};

const REVENUE_SHARING = {
  REVENUE_SHARING_FETCH_LIST: "/transaction-data/transaction-revenue-sharing",
  REVENUE_SHARING_DETAIL_BY_ID: (id: number) =>
    // `/transaction-data/transaction-revenue-sharing/${id}`,
    `/transaction-data/transaction-detail/${id}`,
  REVENUE_SHARING_DOWNLOAD:
    "/transaction-data/transaction-revenue-sharing/download",
};

const PIC_DRIVER = {
  PIC_DRIVER_FETCH_LIST: "/master-data/pic-driver",
  PIC_DRIVER_LIST_DROPDOWN: "/master-data/pic-driver/name-list",
  PIC_DRIVER_FETCH_BY_ID: (id: number) => `/master-data/pic-driver/${id}`,
  PIC_DRIVER_CREATE: `/master-data/pic-driver/add`,
  PIC_DRIVER_UPDATE: `/master-data/pic-driver/edit`,
  PIC_DRIVER_DELETE: `/master-data/pic-driver/delete`,
  PIC_DRIVER_FETCH_KTP: (user_id: number, url: string) =>
    `/master-data/pic-driver/get-link?user_id=${user_id}&object_url=${url}`,
};

const PROFIT_SHARING = {
  PROFIT_SHARING_FETCH_LIST: "/transaction-data/transaction-profit-sharing",
  PROFIT_SHARING_DOWNLOAD:
    "/transaction-data/transaction-profit-sharing/download",
  PROFIT_SHARING_DETAIL_BY_ID: (id: number) =>
    `/transaction-data/transaction-detail/${id}`,
};

const DASHBOARD = {
  DASHBOARD_STATISTICS: "/web/dashboard/statistics",
};

const SIM_CARD = {
  LIST: "/master-data/sim-card/paging",
  FETCH_BY_ID: `/master-data/sim-card`,
  CREATE: `/master-data/sim-card`,
  UPDATE: `/master-data/sim-card`,
  DELETE: (id: number) => `/master-data/sim-card/${id}`,
};

export {
  BASE_URL_AUTH,
  BASE_URL_RESOURCE,
  LOGIN,
  APP_SETTING,
  MASTER_DATA,
  TRANSACTION_DATA,
  PRODUCT,
  DRIVER,
  REVENUE_SHARING,
};

export const ENDPOINTS = {
  BASE_URL_AUTH,
  BASE_URL_RESOURCE,
  LOGIN,
  APP_SETTING,
  MASTER_DATA,
  TRANSACTION_DATA,
  PRODUCT,
  DRIVER,
  REVENUE_SHARING,
  PIC_DRIVER,
  PROFIT_SHARING,
  DASHBOARD,
  SIM_CARD,
};
